export default class ObsoleteResultError extends Error { }
